import { render, staticRenderFns } from "./formEditTrailer.vue?vue&type=template&id=e5a96cf2"
import script from "./formEditTrailer.vue?vue&type=script&lang=js"
export * from "./formEditTrailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5a96cf2')) {
      api.createRecord('e5a96cf2', component.options)
    } else {
      api.reload('e5a96cf2', component.options)
    }
    module.hot.accept("./formEditTrailer.vue?vue&type=template&id=e5a96cf2", function () {
      api.rerender('e5a96cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/components/form/formEditTrailer.vue"
export default component.exports